<template>
    <div v-if="releaseNotes"
         class="box">
        <div class="box-header">
            <div class="row">
                <div class="col">
                    <h3>{{ releaseNotesDate }}, {{ releaseNotes.title }}</h3>
                    <div v-if="releaseNotes.features.length > 0">
                        <h4>Features</h4>
                        <ul>
                            <li v-for="(feature, index) in releaseNotes.features"
                                :key="`f${index}`">
                                {{ feature }}
                            </li>
                        </ul>
                    </div>
                    <div v-if="releaseNotes.bugFixes.length > 0">
                        <h4>Bug Fixes</h4>
                        <ul>
                            <li v-for="(bugFix, index) in releaseNotes.bugFixes"
                                :key="`b${index}`">
                                {{ bugFix }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="box-footer">
            <div>
                <span class="float-left">
                    <button type="button"
                            class="btn btn-primary btn-sm btn-dark-color"
                            :disabled="curReleaseNotes===0"
                            @click="nextReleaseNotes">
                        Newer
                    </button>
                </span>
                <span class="float-right">
                    <button type="button"
                            class="btn btn-primary btn-sm btn-dark-color"
                            :disabled="curReleaseNotes===(releaseNotesCount-1)"
                            @click="prevReleaseNotes">
                        Older
                    </button>
                </span>
            </div>
        </div>
    </div>
</template>


<script>

    import axios from 'axios';
    
    import { axiosError } from '../../js/AjaxUtilities.js';


    export default {
        name: 'ReleaseNotes',
        components: {
        },
        data: () => {
            return {
                releaseNotes: null,
                releaseNotesCount: 0,
                curReleaseNotes: 0,

            }
        },
        computed: {
            releaseNotesDate: function () {
                if (this.releaseNotes?.date) {
                    let dt = new Date(this.releaseNotes.date);
                    return dt.toDateString();
                } else {
                    return '-';
                }
            },
        },

        beforeMount: function () {
            this.initReleaseNotes();
        },

        mounted: function () {
            this.showNewFeatures();
        },

        methods: {
            initReleaseNotes: function () {
                this.releaseNotes = {
                    date: null,
                    title: null,
                    features: [],
                    bugFixes: []
                }
            },
            showNewFeatures: function () {
                this.initReleaseNotes();
                let that = this;

                axios
                    .get('/GetHelp/GetNumReleaseNotes')
                    .then(function (response) {
                        if (response.data.success) {
                            that.releaseNotesCount = response.data.count;
                            if (that.releaseNotesCount > 0) {
                                that.curReleaseNotes = 0;
                                that.loadReleaseNotes()
                            }
                        } else {
                            alert(`Release notes not loaded. ${response.data.message}`);
                        }
                    })
                    .catch(function (error) {
                        axiosError("Get number of release notes", axios, error);
                    });
            },
            // Items stored in reverse chronological, so "previous" is numerically higher
            prevReleaseNotes: function () {
                if (this.curReleaseNotes < (this.releaseNotesCount - 1)) {
                    this.curReleaseNotes = this.curReleaseNotes + 1;
                    this.loadReleaseNotes()
                }
            },
            nextReleaseNotes: function () {
                if (this.curReleaseNotes > 0) {
                    this.curReleaseNotes = this.curReleaseNotes - 1;
                    this.loadReleaseNotes()
                }
            },
            loadReleaseNotes: function () {
                let that = this;

                axios
                    .get(`/GetHelp/GetReleaseNotes?index=${this.curReleaseNotes}`)
                    .then(function (response) {
                        that.releaseNotes = response.data.releaseNotes;
                        that.$forceUpdate();
                    })
                    .catch(function (error) {
                        axiosError("Get release notes", axios, error);
                    });
            },
        }
    }

</script>

<style>
</style>
